<template>
  <div class="">
    <div class="row">
      <div class="col-12 pl-3 pr-3 pt-2">
        <h3 class="text-uppercase e-text-red font-weight-bold">Inspection Settings</h3>
      </div>
    </div>
    <hr class="border border-secondary border-3" style="z-index: -1; opacity: 0.4;">
    <div class="row">
      <div class="col-12">
        <ul class="nav nav-pills nav-fill">
          <li class="nav-item">
            <a class="nav-link text-uppercase font-weight-bold h6" style="cursor:pointer;" :class="selected === 'companies' ? 'active' : ''" @click="selectTab('companies')">List of Companies</a>
          </li>
          <li class="nav-item">
            <a class="nav-link text-uppercase font-weight-bold h6" style="cursor:pointer;" :class="selected === 'inspectors' ? 'active' : ''" @click="selectTab('inspectors')">List of Inspectors</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card mb-4">
          <div class="card-body">
            <template v-if="selected === 'inspectors'">
              <SettingInspector></SettingInspector>
            </template>
            <template v-else>
              <SettingCompany></SettingCompany>
            </template>
          </div>
        </div>

      </div>
    </div>

    <router-view :key="$route.params.feature"></router-view>
  </div>
</template>

<style scoped>
a.nav-link.text-uppercase.font-weight-bold.h6.active {
  background: #d3313c !important;
  color: #fff;
  font-weight: bold;
}

a.nav-link.text-uppercase.font-weight-bold.h6{
  color: #d3313c;
}
</style>

<script>
import {mapActions, mapGetters} from "vuex";
import SettingInspector from "@/components/settings/rightship-inspection/RightshipInspectorList.vue";
import SettingCompany from "@/components/settings/rightship-inspection/RightshipCompanyList.vue";

export default {
  name: 'SettingInspection',
  components: {SettingCompany, SettingInspector},
  data(){
    return {
      selected: 'companies',
    }
  },
  methods : {
    selectTab(data){
      this.selected = data;
    },
  },
  computed: {
  },
}


</script>
